
import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import homeLogo from "../../Assets/home-main.svg";
import Particle from "../Particle";
import Home2 from "./Home2";
import Type from "./Type";
import { AiFillGithub, AiOutlineTwitter } from "react-icons/ai";
import { FaLinkedinIn } from "react-icons/fa";

function Home() {
  return (
    <section>
      <Container fluid className="home-section" id="home">
        <Particle />

        <Container className="home-content">
          <Row className="home-hero-row">
            <Col md={7} className="home-header">
              <h2 className="intro-name">
                Hey everyone! My name is{" "}
                <span className="purple">MATTHEW</span>{" "}
                <span role="img" aria-label="waving hand">
                  👋
                </span>
              </h2>

              <div className="home-typewriter">
                <Type />
              </div>

              <p className="home-intro-description">
                I'm a Cybersecurity Engineer focused on vulnerability
                research, exploit development, penetration testing, and
                security tool development. This portfolio showcases my
                technical projects, practical security experiments, and
                hands-on work in cybersecurity.
              </p>
            </Col>

            <Col md={5} className="home-hero-image">
              <img
                src={homeLogo}
                alt="Cybersecurity portfolio illustration"
                className="img-fluid"
              />
            </Col>
          </Row>
        </Container>
      </Container>

      <Home2 />

      <Container>
        <Row className="home-connect-row">
          <Col md={12} className="home-about-social">
            <h1>Connect With Me</h1>

            <p>
              Let's connect and discuss{" "}
              <span className="purple">
                cybersecurity and technology.
              </span>
            </p>

            <ul className="home-about-social-links">
              <li className="social-icons">
                <a
                  href="https://github.com/wilecurity"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="GitHub"
                  className="icon-colour home-social-icons"
                >
                  <AiFillGithub />
                </a>
              </li>

              <li className="social-icons">
                <a
                  href="https://www.linkedin.com/in/matthew-omojola/"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="LinkedIn"
                  className="icon-colour home-social-icons"
                >
                  <FaLinkedinIn />
                </a>
              </li>

              <li className="social-icons">
                <a
                  href="https://x.com/Wilecuritycyber"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="X"
                  className="icon-colour home-social-icons"
                >
                  <AiOutlineTwitter />
                </a>
              </li>
            </ul>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Home;
